import type { ClosestMatch, ModerationCandidatePiece } from '@/lib/queries/moderation';

const COMPOSER_FALLBACK = 'Traditional';

export type DiffRow = {
  label: string;
  candidate: string;
  match: string | null;
  differs: boolean;
};

export function buildDiffRows(
  candidate: ModerationCandidatePiece,
  match: ClosestMatch | null,
): DiffRow[] {
  const candidateComposer = candidate.composerName ?? COMPOSER_FALLBACK;
  const matchComposer = match ? (match.composerName ?? COMPOSER_FALLBACK) : null;
  return [
    diffRow('Title', candidate.prettyName, match?.prettyName ?? null),
    diffRow('Composer', candidateComposer, matchComposer),
  ];
}

function diffRow(label: string, candidate: string, match: string | null): DiffRow {
  return {
    label,
    candidate,
    match,
    differs: match !== null && normalise(candidate) !== normalise(match),
  };
}

function normalise(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}
